module.exports = __webpack_public_path__ + "img/novo-nordisk-logo.70df8b62.svg";